// @vendor
import React from 'react';
import PropTypes from 'prop-types';
import isNumber from 'lodash/lang/isNumber';

// @utilities
import { formatAmount } from 'utilities/currencyHelper';

// @components
import { InputSafe } from 'commonsComponents/inputSafe';

// @constants
//(nicolas.olmos): this regex allows the user to delete the input, and checks the order of the characters
const VALID_FLOAT_OR_EMPTY = /^(-?((\d+(\.\d*))|(\d*)))?$/;

class maskedAmount extends React.Component {
    constructor(props) {
        super(props);
        const originalAmount = this.props.amount;
        const amountParsed = formatAmount(this.props.amount);
        this.state = {
            amount: amountParsed,
            originalAmount
        };
        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.amount !== this.state.originalAmount) {
            this.setState({
                amount: formatAmount(nextProps.amount),
                originalAmount: nextProps.amount
            });
        }
    }

    handleBlur(evt) {
        const { min, max } = this.props;
        //if the input is empty, we set default value to always return a number.
        const originalAmount = this.state.amount === '' ? 0 : this.state.amount;
        const amountParsed = formatAmount(originalAmount);

        if ((isNumber(max) && originalAmount > max) || (isNumber(min) && originalAmount < min)) {

            this.setState({
                amount: this.state.originalAmount,
            });
            return false;
        }

        this.setState({
            amount: amountParsed,
            originalAmount
        });
        this.props.callback(parseFloat(originalAmount), evt);
    }

    handleChange(evt) {
        const amount = evt.target.value;

        if (VALID_FLOAT_OR_EMPTY.test(amount)) {
            this.setState({
                amount
            });
        }
    }

    handleFocus() {
        this.setState({
            //clear the input when zero (default value) is displayed.
            amount: this.state.originalAmount === 0 ? '' : this.state.originalAmount
        })
    }

    render() {
        const {
             id,
             disabled,
             error,
             errorMsg,
             label,
             optionalElement,
             width
         } = this.props;

         // We are using inline style to be able to pass the width to the component.
         // Apparently, this is the only property that we need to change in styles.
         // There is no need of a style sheet for one property.

        return (
            <div
                className="masked-amount"
                style={{ width }}
            >
                <InputSafe
                    id={id}
                    name={id}
                    label={label}
                    type="text"
                    autoComplete="off"
                    value={this.state.amount}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onFocus={this.handleFocus}
                    disabled={disabled}
                    errorState={error}
                    errorMessage={errorMsg}
                    optionalElement={optionalElement}
                />
            </div>
        )
    }
}

maskedAmount.propTypes = {
    amount: PropTypes.any,
    callback: PropTypes.func,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    label: PropTypes.string,
    optionalElement: PropTypes.object,
    width: PropTypes.string
};

maskedAmount.defaultProps = {
    amount: 0,
    id: '',
    disabled: false,
    errorMsg: '',
    label: '',
    width: '216px'
};

module.exports = maskedAmount;
